<zxing-scanner
  #scanner
  [formats]="formats"
  [device]="device"
  [autofocusEnabled]="autofocusEnabled"
  [previewFitMode]="previewFitMode"
  [torch]="torch"
  (torchCompatible)="torchCompatible.next($event)"
  (scanSuccess)="scanSuccess.next($event)"
  (scanFailure)="scanFailure.next($event)"
  (scanError)="scanError.next($event)"
  (scanComplete)="scanComplete.next($event)"
  (camerasFound)="camerasFound.next($event)"
  (camerasNotFound)="camerasNotFound.next($event)"
  (permissionResponse)="permissionResponse.next($event)"
  (hasDevices)="hasDevices.next($event)">

</zxing-scanner>

